var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q4vpgq7qva)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.365.97a.75.75 0 0 1 .53-.22h6.21a.75.75 0 0 1 .53.22l4.395 4.395c.141.14.22.331.22.53v6.21a.75.75 0 0 1-.22.53l-4.395 4.395a.75.75 0 0 1-.53.22h-6.21a.75.75 0 0 1-.53-.22L.97 12.635a.75.75 0 0 1-.22-.53v-6.21a.75.75 0 0 1 .22-.53L5.365.97z",
    fill: "#EAB308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.995 4.313c.516 0 .933.42.933.937V9a.935.935 0 0 1-.933.938A.935.935 0 0 1 8.063 9V5.25c0-.518.417-.938.932-.938zM8.063 12.75c0-.518.417-.938.932-.938h.01c.515 0 .932.42.932.938a.935.935 0 0 1-.932.938h-.01a.935.935 0 0 1-.932-.938z",
    fill: "#fff"
  }))), "\"#B2B2B2\"\n    ", _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q4vpgq7qva"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIcon);
export default __webpack_public_path__ + "static/media/cautionIcon.e9435540a5b07ccc2b2de7f2e4505d41.svg";
export { ForwardRef as ReactComponent };